import React from 'react';
import { motion } from 'framer-motion';
import { MenuItem } from './MenuItem';
import { RecipeSteps } from '../recipe/RecipeSteps';
import { MenuSuggestion } from '../../../types/Menu';
import { ChefHat } from 'lucide-react';

interface MenuDisplayProps {
  menu: MenuSuggestion | null;
  recipeSteps?: string;
  showRecipe?: boolean;
  useThermomix?: boolean;
}

export const MenuDisplay: React.FC<MenuDisplayProps> = ({
  menu,
  recipeSteps = '',
  showRecipe = false,
  useThermomix = false
}) => {
  if (!menu) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="mt-8 bg-white rounded-lg p-6 shadow-lg"
    >
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <ChefHat className="text-orange-500" size={24} />
          <div>
            <h3 className="text-xl font-bold text-gray-800">{menu.name}</h3>
            <p className="text-gray-600">{menu.description}</p>
          </div>
        </div>
        {typeof menu.totalPrice === 'number' && (
          <div className="flex items-center gap-2 bg-orange-50 px-4 py-2 rounded-lg">
            <span className="text-lg font-bold text-orange-600">
              {menu.totalPrice.toFixed(2)}€
            </span>
          </div>
        )}
      </div>

      <div className="space-y-4">
        {Array.isArray(menu.items) && menu.items.map((item, index) => (
          <MenuItem
            key={index}
            item={item}
            index={index}
          />
        ))}
      </div>

      {showRecipe && recipeSteps && (
        <RecipeSteps
          steps={recipeSteps}
          useThermomix={useThermomix}
        />
      )}
    </motion.div>
  );
};